export default {
  header: '',
  link: 'Clear all',
  footer: '',
};



// WEBPACK FOOTER //
// ./~/instantsearch.js/src/widgets/clear-all/defaultTemplates.js